/* Built In Imports */
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

/* External Imports */
import { Box, Flex, Heading } from '@chakra-ui/react';
import { refineUrlDomain } from '@eternal/Components/Utility/utils';
import { render } from 'datocms-structured-text-to-html-string';
import { useMediaQuery } from 'react-responsive';
/* Internal Imports */
/* Components */
// import StructuredTextContent from '@eternal/Components/Utility/StructuredTextParser';
import StructuredTextParser from '@eternal/Components/Utility/StructuredTextParser';

/* Services */

/**
 * Renders the LandingPageTopBanner component.
 *
 * @param src
 * @param width
 * @param quality
 */

const imageLoader = ({ src, quality }) => {
  return `${src}?q=${quality || 75}`;
};
const LandingPageTopBanner = ({
  sectionContent,
  region,
  language,
  startTime,
  endTime,
  csrData,
  disabled = false,
  timezone,
  currentRegion,
  prgDate,
  pNameAlias,
}) => {
  const router = useRouter();

  const [currentUrl, setCurrentUrl] = useState('');
  let reg_URL = '';
  if (csrData) {
    reg_URL = csrData?.result[0]?.url_registration;
  }
  const isMobile = useMediaQuery({ maxWidth: 767 });
  useEffect(() => {
    if (sectionContent?.button[0]) {
      setCurrentUrl(
        refineUrlDomain(sectionContent?.button[0]?.linkUrl, region, language)
      );
    } else if (reg_URL != '' && currentRegion != 'IN') {
      setCurrentUrl(refineUrlDomain(reg_URL, region, language));
    }
  }, [sectionContent?.button[0]?.linkUrl, reg_URL]);
  return (
    <>
      <Box
        w="100%"
        height={{ base: 460, lg: 715 }}
        pos="relative"
        background="#121212"
      >
        <Box
          width="100%"
          height="100%"
          pos="absolute"
          top={0}
          bottom={0}
          right={0}
        >
          <Image
            fill
            priority
            loader={imageLoader}
            src={
              isMobile
                ? sectionContent?.mobileImage?.url
                : sectionContent?.desktopImage?.url
            }
            blurDataURL={sectionContent?.mobileImage?.url + '?q=50'}
            placeholder="blur"
            alt={
              sectionContent?.mobileImage?.alt ||
              sectionContent?.desktopImage?.alt ||
              ''
            }
            loading={'eager'}
            style={{
              objectFit: isMobile ? 'contain' : 'cover',
              objectPosition: 'top',
            }}
          />
        </Box>
        <Flex
          position="absolute"
          top={{ base: '0', md: 0 }}
          left={0}
          w="100%"
          right={0}
          bottom={0}
          alignItems="center"
          h="100%"
        >
          <Box
            maxW={{ base: '100%', md: 560 }}
            w={{ base: '100%', md: '100%' }}
            mr={{ base: 'auto' }}
            marginLeft={{ base: '0', md: 93 }}
            mt={{ base: '310px', md: '20px' }}
            height="auto"
            px={{ base: '40px', md: '0' }}
          >
            {/* Heading of the banner */}
            {sectionContent?.title && sectionContent?.title.length && (
              <Heading
                fontSize={{ base: '32px', md: '60px', lg: '80px', xl: '100px' }}
                as="h1"
                lineHeight={{ base: '30px', md: '76px', lg: '96px' }}
                fontFamily="FedraSerifAStdBook"
                textTransform="uppercase"
                color="#C9BAAB"
                textAlign={{ base: 'center', md: 'left' }}
                fontWeight="300"
                maxW={{ base: 'none', md: 300, lg: 500 }}
                mx={{ base: 'auto', md: '0' }}
              >
                {sectionContent?.title}
              </Heading>
            )}

            {/* description of the banner */}
            {sectionContent?.titleSubtext && (
              <Box
                maxW={{ base: 240, sm: 286, xl: 450 }}
                mx={{ base: 'auto', md: '0' }}
              >
                <StructuredTextParser
                  fontStyle="normal"
                  fontSize={{ base: '16px', md: '20px', xl: '30px' }}
                  lineHeight={{ base: '22px', md: '30px', xl: '40px' }}
                  color="#F8FAFC"
                  textAlign={{ base: 'center', md: 'left' }}
                  fontFamily="FedraSansStd-book"
                  mt={{ base: '14px', md: '22px', lg: '40px' }}
                  marginTop={{ base: '14px', md: '22px', lg: '40px' }}
                  str={render(sectionContent?.titleSubtext)}
                  className={'sub-text'}
                />
              </Box>
            )}
          </Box>
        </Flex>
      </Box>
    </>
  );
};

export default LandingPageTopBanner;
